module.exports = __webpack_public_path__ + "img/contentImg3.045562a.webp";